import React from 'react';
import { Divider as DividerAnt } from 'antd';
import styles from './styles.module.less';

const Divider = props => {
  return (
    <DividerAnt className={styles.divider} {...props}>
      {props ? props.children : null}
    </DividerAnt>
  );
};

export default Divider;
